























































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Modal as AntModal } from 'ant-design-vue';

import Modal from '@/components/UI/Modal.vue';

import MmHintedButton from '../../components/MmHintedButton.vue';

const KEY = 'priceMonitoring.mobileMonitoring.taskResults.';

const COMMENT_MAX_LENGTH = 1000;

type MmBulkPendingAction = 'accept' | 'reject' | 'delete' | null;

@Component({
	components: {
		MmHintedButton,
		Modal,
	},
})
export default class TaskResultsBulkBar extends Vue {
	@Prop({ default: 0 }) readonly selectedCount!: number;

	@Prop({ default: 0 }) readonly total!: number;

	@Prop({ default: false }) readonly canDelete!: boolean;

	@Prop({ default: '' }) readonly acceptBlockedReasonKey!: string;

	@Prop({ default: false }) readonly busy!: boolean;

	@Prop({ default: false }) readonly canCorrect!: boolean;

	pendingAction: MmBulkPendingAction = null;

	isRejectModalVisible: boolean = false;
	comment: string = '';
	commentError: string = '';

	get keyPrefix(): string {
		return KEY;
	}

	fieldControlId(field: string): string {
		return 'sm-mobilemon-bulk-' + field + '-control-' + String((this as any)._uid);
	}

	get commentMaxLength(): number {
		return COMMENT_MAX_LENGTH;
	}

	get selectedText(): string {
		return this.$t(KEY + 'selectedOf', { selected: this.selectedCount, total: this.total }) as string;
	}

	get isSelectionEmpty(): boolean {
		return this.selectedCount <= 0;
	}

	get actionDisabledReason(): string {
		if (this.isSelectionEmpty) {
			return this.$t(KEY + 'bulkDisabledEmpty') as string;
		}

		return this.busy ? (this.$t(KEY + 'actionBusy') as string) : '';
	}

	get clearDisabledReason(): string {
		return this.busy ? (this.$t(KEY + 'actionBusy') as string) : '';
	}

	get isAcceptDisabled(): boolean {
		return this.isSelectionEmpty || this.acceptBlockedReasonKey !== '' || this.busy;
	}

	get acceptDisabledReason(): string {
		if (this.acceptBlockedReasonKey !== '') {
			return this.$t(this.acceptBlockedReasonKey) as string;
		}

		return this.actionDisabledReason;
	}

	get correctDisabledReason(): string {
		return this.canCorrect ? '' : (this.$t(KEY + 'bulkDisabledEmpty') as string);
	}

	get isRejectSubmitDisabled(): boolean {
		return this.busy || this.comment.trim() === '';
	}

	get rejectSubmitDisabledReason(): string {
		if (!this.isRejectSubmitDisabled || this.busy) {
			return '';
		}

		return this.$t(KEY + 'rejectCommentRequired') as string;
	}

	handleAcceptClick(): void {
		if (this.isAcceptDisabled) {
			return;
		}

		this.confirm(
			this.$t(KEY + 'confirmAcceptTitle') as string,
			this.$t(KEY + 'confirmAccept', { count: this.selectedCount }) as string,
			'',
			false,
			() => {
				this.pendingAction = 'accept';
				this.$emit('accept');
			},
		);
	}

	handleRejectClick(): void {
		if (this.isSelectionEmpty || this.busy) {
			return;
		}

		this.comment = '';
		this.commentError = '';
		this.isRejectModalVisible = true;
	}

	handleCommentInput(event: any): void {
		const value = event && event.target ? event.target.value : '';

		this.comment = value === null || value === undefined ? '' : String(value);

		if (this.comment.trim() !== '') {
			this.commentError = '';
		}
	}

	handleRejectSubmit(): void {
		if (this.busy) {
			return;
		}

		if (this.comment.trim() === '') {
			this.commentError = this.$t(KEY + 'rejectCommentRequired') as string;

			return;
		}

		this.pendingAction = 'reject';
		this.$emit('reject', this.comment.trim());
	}

	handleRejectCancel(): void {
		if (this.busy) {
			return;
		}

		this.isRejectModalVisible = false;
		this.comment = '';
		this.commentError = '';
	}

	handleDeleteClick(): void {
		if (this.isSelectionEmpty || this.busy) {
			return;
		}

		this.confirm(
			this.$t(KEY + 'confirmDeleteTitle') as string,
			this.$t(KEY + 'confirmDelete', { count: this.selectedCount }) as string,
			this.$t(KEY + 'confirmDeleteIrreversible') as string,
			true,
			() => {
				this.pendingAction = 'delete';
				this.$emit('delete');
			},
		);
	}

	handleCorrectClick(): void {
		if (!this.canCorrect || this.busy) {
			return;
		}

		this.$emit('correct');
	}

	handleClear(): void {
		if (this.busy) {
			return;
		}

		this.$emit('clear');
	}

	/** При отказе окно остаётся открытым и комментарий сохраняется: повтора запроса нет */
	finishAction(success: boolean): void {
		this.pendingAction = null;

		if (success) {
			this.isRejectModalVisible = false;
			this.comment = '';
			this.commentError = '';
		}
	}

	private confirm(title: string, content: string, extra: string, danger: boolean, onOk: () => void): void {
		const body = extra === '' ? content : content + ' ' + extra;

		AntModal.confirm({
			title: title,
			content: body,
			okText: danger ? (this.$t('shared.actions.delete') as string) : (this.$t('shared.actions.ok') as string),
			okType: danger ? 'danger' : 'primary',
			cancelText: this.$t('shared.actions.cancel') as string,
			onOk: onOk,
		});
	}
}
